export default function baseUrl() {
  if (import.meta.env.REACT_APP_DEPLOY_ENV === 'production') {
    return import.meta.env.REACT_APP_POCAPAN_PRODUCTION_HOST;
  }
  if (import.meta.env.REACT_APP_DEPLOY_ENV === 'development') {
    return import.meta.env.REACT_APP_POCAPAN_DEVELOPMENT_HOST;
  }
  return import.meta.env.REACT_APP_POCAPAN_LOCAL_HOST;
}
